import { render } from "./EventLatestVideos.vue?vue&type=template&id=3b908a46"
import script from "./EventLatestVideos.vue?vue&type=script&lang=js"
export * from "./EventLatestVideos.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__